import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ERoutes } from '../../enums';
import { ToasterService } from '../../../services/toaster/toaster.service';
import { AuthStore } from '../../../store/auth.store';

export const identityVerificationGuard: CanActivateFn = () => {
  const authStore = inject(AuthStore);
  const router = inject(Router);
  const toaster = inject(ToasterService);

  if (authStore.user()?.identityVerified === true) {
    return true;
  }

  toaster.addWarning('Please verify your identity before creating a trip or delivery request.');
  return router.createUrlTree([`/${ERoutes.basicInfo}`]);
};
